import FeedPage from '~/pageComponents/FeedPage';
import getLandingPageProps from '~/pageProps/landing';

export default FeedPage;

export const getServerSideProps = getLandingPageProps;
